/* js/components/socialShare/Telegram.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	assign,
	attr,
	compute_rest_props,
	create_component,
	destroy_component,
	detach,
	exclude_internal_props,
	get_spread_object,
	get_spread_update,
	init,
	insert,
	mount_component,
	safe_not_equal,
	svg_element,
	transition_in,
	transition_out
} from "svelte/internal";

import ShareButton from './ShareButton.svelte';

function create_default_slot(ctx) {
	let svg;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "d", "M.707 8.475C.275 8.64 0 9.508 0 9.508s.284.867.718 1.03l5.09 1.897 1.986 6.38a1.102 1.102 0 0 0 1.75.527l2.96-2.41a.405.405 0 0 1 .494-.013l5.34 3.87a1.1 1.1 0 0 0 1.046.135 1.1 1.1 0 0 0 .682-.803l3.91-18.795A1.102 1.102 0 0 0 22.5.075L.706 8.475z");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "viewBox", "0 0 24 24");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

function create_fragment(ctx) {
	let sharebutton;
	let current;

	const sharebutton_spread_levels = [
		{
			class: "ssbc-button--telegram " + /*classes*/ ctx[1]
		},
		/*$$restProps*/ ctx[3],
		{ ariaLabel: /*ariaLabel*/ ctx[0] },
		{ href: /*href*/ ctx[2] }
	];

	let sharebutton_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	for (let i = 0; i < sharebutton_spread_levels.length; i += 1) {
		sharebutton_props = assign(sharebutton_props, sharebutton_spread_levels[i]);
	}

	sharebutton = new ShareButton({ props: sharebutton_props });

	return {
		c() {
			create_component(sharebutton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(sharebutton, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const sharebutton_changes = (dirty & /*classes, $$restProps, ariaLabel, href*/ 15)
			? get_spread_update(sharebutton_spread_levels, [
					dirty & /*classes*/ 2 && {
						class: "ssbc-button--telegram " + /*classes*/ ctx[1]
					},
					dirty & /*$$restProps*/ 8 && get_spread_object(/*$$restProps*/ ctx[3]),
					dirty & /*ariaLabel*/ 1 && { ariaLabel: /*ariaLabel*/ ctx[0] },
					dirty & /*href*/ 4 && { href: /*href*/ ctx[2] }
				])
			: {};

			if (dirty & /*$$scope*/ 64) {
				sharebutton_changes.$$scope = { dirty, ctx };
			}

			sharebutton.$set(sharebutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sharebutton, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = ["text","url","ariaLabel","class"];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { text } = $$props;
	let { url } = $$props;
	let { ariaLabel = 'Share on Telegram' } = $$props;
	let { class: classes = '' } = $$props;
	let href;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
		if ('text' in $$new_props) $$invalidate(4, text = $$new_props.text);
		if ('url' in $$new_props) $$invalidate(5, url = $$new_props.url);
		if ('ariaLabel' in $$new_props) $$invalidate(0, ariaLabel = $$new_props.ariaLabel);
		if ('class' in $$new_props) $$invalidate(1, classes = $$new_props.class);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*text, url*/ 48) {
			$: $$invalidate(2, href = encodeURI(`https://telegram.me/share/url?text=${text}&url=${url}`));
		}
	};

	return [ariaLabel, classes, href, $$restProps, text, url];
}

class Telegram extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { text: 4, url: 5, ariaLabel: 0, class: 1 });
	}
}

export default Telegram;